import { mutatorAction } from 'satcheljs';
import mailGroupHeadersStore from '../store/store';

export const removeGroupHeaderAction = mutatorAction(
    'removeGroupHeader',
    (groupHeaderId: string) => {
        mailGroupHeadersStore().groupHeaders.delete(groupHeaderId);
    }
);
